import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Tag from '~/modules/addListing/pages/DetailsStep/Tag';
import {
  addListingDetailsType,
  CustomFieldsType,
  ListingDetailsType,
} from '~addListing/types';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const FinishType = ({
  customFieldsData,
  listing,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  customFieldsData: { attributes: CustomFieldsType[] };
  listing: ListingDetailsType;
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const { setValue, getValues } = useFormContext<addListingDetailsType>();

  if (!customFieldsData) return null;

  const finishTypeData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === 'finish-type',
  );
  const finishTypeId = Number(finishTypeData?.id);
  const isError = errorAttributeIds.includes(finishTypeId);

  const renderFinishType = Object.values(
    finishTypeData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);
  const defaultFinishTypeValue =
    listing?.attributes.find((att) => att.custom_field.id === finishTypeId)
      ?.value || 0;

  if (!renderFinishType) return null;

  const handleChange = (key: string) => {
    setErrorAttributeIds((prev) => prev.filter((id) => id !== finishTypeId));
    setValue(
      'attributes',
      handleAttributeChange(getValues('attributes'), finishTypeId, key),
    );
    setSelectedTag(key);
  };

  useEffect(() => {
    setSelectedTag(`${defaultFinishTypeValue}`);
  }, []);

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        finishTypeId,
        defaultFinishTypeValue,
      ),
    );
  }, []);

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('finishType')}</p>
      <div className="flex flex-wrap gap-1.5x">
        {Object.entries(finishTypeData?.options?.choices || []).map(
          ([key, val]) => (
            <Tag
              key={val}
              text={t(key, { defaultValue: val })}
              isSelected={selectedTag === key}
              onClick={() => handleChange(key)}
              className={isError ? '!border-red_dark' : '!border-gray'}
            />
          ),
        )}
      </div>
      {isError && <p className="text-red_dark">{t('finishTypeRequired')}</p>}
    </div>
  );
};

export default FinishType;
